import { useContext } from "react";
import { ProjectIdContext } from "../context/Contexts";

export const useProjectId = () => useContext(ProjectIdContext) || {};

